module.exports = __webpack_public_path__ + "static/media/meetingRoom.993da013.png";